// hooks/useAdminGuard.js
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const useAdminGuard = (isAdmin, onPremises) => {
  const navigate = useNavigate();

  useEffect(() => {
    if (!isAdmin || onPremises) {
      navigate("/"); // Redirect to home
    }
  }, [isAdmin, navigate]);
};

export default useAdminGuard;
